<template>
  <header class="header-image">
    <img src="../assets/CABEZOTE VOLUNTARIADO.png" alt="Header Image" />
  </header>
</template>

<style scoped>
.header-image {
  width: 100%;
}

.header-image img {
  width: 100%;
  height: auto;
  display: block;
  max-width: 100%;
}

@media (min-width: 1024px) {
  .header-image img {
    max-height: 200px; 
    object-fit: contain; 
  }
}
</style>
